import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormField, FormFieldType, FormType } from "shared/modals/ApplicationEditor/constants";

type VariantOption = {
  visible: boolean;
  optionIndex: number;
}
export interface ApplicationEditorSliceState {
  isLoading: boolean;
  formId: string;
  fields: FormField[];
  docs: FormField[];
  header: LangObjectArray;
  description: LangObjectArray;
  oldCheckboxes: LangObjectArray[]
  variantOption: VariantOption;
  formType: FormType;
}

const initialVariantOption: VariantOption = {
  visible: false,
  optionIndex: 0,
}

const initialState: ApplicationEditorSliceState = {
  isLoading: false,
  formId: '',
  fields: [],
  docs: [],
  header: [],
  description: [],
  oldCheckboxes: [],
  formType: FormType.base,
  variantOption: initialVariantOption,
};

export const ApplicationEditorSlice = createSlice({
  name: "applicationEditor",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFormId: (state, action: PayloadAction<string>) => {
      state.formId = action.payload;
    },
    setInitialData: (state, action: PayloadAction<{ 
      formId: string, 
      fields: FormField[], 
      docs: FormField[], 
      oldCheckboxes: LangObjectArray[], 
      formType: FormType,
      header: LangObjectArray,
      description: LangObjectArray
    }>) => {
      state.formId = action.payload.formId;
      state.fields = action.payload.fields;
      state.docs = action.payload.docs;
      state.oldCheckboxes = action.payload.oldCheckboxes;
      state.formType = action.payload.formType;
      state.header = action.payload.header;
      state.description = action.payload.description;
    },
    setHeader: (state, action: PayloadAction<LangObjectArray>) => {
      state.header = action.payload;
    },
    setDescription: (state, action: PayloadAction<LangObjectArray>) => {
      state.description = action.payload;
    },
    setFields: (state, action: PayloadAction<FormField[]>) => {
      state.fields = action.payload;
    },
    addField: (state, action: PayloadAction<FormField>) => {
      state.fields.push(action.payload);
    },
    removeField: (state, action: PayloadAction<number>) => {
      state.fields = state.fields.filter((_, idx) => idx !== action.payload);
    },
    setDocs: (state, action: PayloadAction<FormField[]>) => {
      state.docs = action.payload;
    },
    addDoc: (state, action: PayloadAction<FormField>) => {
      state.docs.push(action.payload);
    },
    removeDoc: (state, action: PayloadAction<number>) => {
      state.docs = state.docs.filter((_, idx) => idx !== action.payload);
    },
    setVariantOption: (state, action: PayloadAction<VariantOption>) => {
      state.variantOption = action.payload;
    },
    resetVariantOption: (state) => {
      state.variantOption = initialVariantOption;
    },
    resetState: () => initialState,
  },
});

export default ApplicationEditorSlice;
export const ApplicationEditorActions = ApplicationEditorSlice.actions;
export const ApplicationEditorSelector = (store: {
  applicationEditor: ApplicationEditorSliceState;
}): ApplicationEditorSliceState => store.applicationEditor;

import { LangObjectArray } from "@brg/api/dist/api-core/utils/lang-utils";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormField, FormFieldType, FormType } from "shared/modals/ApplicationEditor/constants";

type VariantOption = {
  visible: boolean;
  optionIndex: number;
}
export interface ApplicationEditorSliceState {
  isLoading: boolean;
  formId: string;
  fields: FormField[];
  docs: FormField[];
  header: LangObjectArray;
  description: LangObjectArray;
  oldCheckboxes: LangObjectArray[]
  variantOption: VariantOption;
  formType: FormType;
}

const initialVariantOption: VariantOption = {
  visible: false,
  optionIndex: 0,
}

const initialState: ApplicationEditorSliceState = {
  isLoading: false,
  formId: '',
  fields: [],
  docs: [],
  header: [],
  description: [],
  oldCheckboxes: [],
  formType: FormType.base,
  variantOption: initialVariantOption,
};

export const ApplicationEditorSlice = createSlice({
  name: "applicationEditor",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setFormId: (state, action: PayloadAction<string>) => {
      state.formId = action.payload;
    },
    setInitialData: (state, action: PayloadAction<{ 
      formId: string, 
      fields: FormField[], 
      docs: FormField[], 
      oldCheckboxes: LangObjectArray[], 
      formType: FormType,
      header: LangObjectArray,
      description: LangObjectArray
    }>) => {
      state.formId = action.payload.formId;
      state.fields = action.payload.fields;
      state.docs = action.payload.docs;
      state.oldCheckboxes = action.payload.oldCheckboxes;
      state.formType = action.payload.formType;
      state.header = action.payload.header;
      state.description = action.payload.description;
    },
    setHeader: (state, action: PayloadAction<LangObjectArray>) => {
      state.header = action.payload;
    },
    setDescription: (state, action: PayloadAction<LangObjectArray>) => {
      state.description = action.payload;
    },
    setFields: (state, action: PayloadAction<FormField[]>) => {
      state.fields = action.payload;
    },
    addField: (state, action: PayloadAction<FormField>) => {
      state.fields.push(action.payload);
    },
    removeField: (state, action: PayloadAction<number>) => {
      state.fields = state.fields.filter((_, idx) => idx !== action.payload);
    },
    setDocs: (state, action: PayloadAction<FormField[]>) => {
      state.docs = action.payload;
    },
    addDoc: (state, action: PayloadAction<FormField>) => {
      state.docs.push(action.payload);
    },
    removeDoc: (state, action: PayloadAction<number>) => {
      state.docs = state.docs.filter((_, idx) => idx !== action.payload);
    },
    setVariantOption: (state, action: PayloadAction<VariantOption>) => {
      state.variantOption = action.payload;
    },
    resetVariantOption: (state) => {
      state.variantOption = initialVariantOption;
    },
    resetState: () => initialState,
  },
});

export default ApplicationEditorSlice;
export const ApplicationEditorActions = ApplicationEditorSlice.actions;
export const ApplicationEditorSelector = (store: {
  applicationEditor: ApplicationEditorSliceState;
}): ApplicationEditorSliceState => store.applicationEditor;

